module.exports = __webpack_public_path__ + "static/img/qiangchai.e5c02fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/qiangchai.png
// module id = IxrW
// module chunks = 24